import { render, staticRenderFns } from "./leave-guide.vue?vue&type=template&id=23f7c310&"
import script from "./leave-guide.vue?vue&type=script&lang=js&"
export * from "./leave-guide.vue?vue&type=script&lang=js&"
import style0 from "./leave-guide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports